export enum Features {
  BROWSE_ABANDONMENT = "browse-abandonment",
  COME_BACK_MAILING = "come-back-mailing"
}
